import lang from "../../lib/appfuse-react/core/lang";
import cropApplication from "./cropApplication";

const cropApplicationService = [{
    matcher: 'cropApplication',
    reply: config => {
        if(config.method==='post') {
            return [200, cropApplication[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if(lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, cropApplication];
                }
                if(selector === 'appNo' || selector === 'farmerName') {
                    const regexp = new RegExp(value.replaceAll('*', '.*'));
                    data = cropApplication.filter(crop => regexp.test(crop[selector]));
                } else if(selector === 'activity' || selector === 'appStatus' || selector === 'type') {
                    data = cropApplication.filter(crop => crop[selector] === value);
                } else if(selector==='createdOnStart') {
                    data = cropApplication.filter(crop => crop.createdOn >= value);
                } else if(selector==='createdOnEnd') {
                    data = cropApplication.filter(crop => crop.createdOn <= value);
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = cropApplication;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const selector = child.selector();
                    if(selector === 'appNo' || selector === 'farmerName') {
                        const regexp = new RegExp(value.replaceAll('*', '.*'));
                        tmp = tmp.filter(crop => regexp.test(crop[selector]));
                    } else if(selector === 'activity' || selector === 'appStatus' || selector === 'type') {
                        tmp = tmp.filter(crop => crop[selector] === value);
                    } else if(selector==='createdOnStart') {
                        tmp = tmp.filter(crop => crop.createdOn >= value);
                    } else if(selector==='createdOnEnd') {
                        tmp = tmp.filter(crop => crop.createdOn <= value);
                    }
                }
                data = tmp;
            } else {
                data = cropApplication;
            }
            return [200, data];
        }
    }
}, {
    matcher: /cropApplication\/(.*)/,
    reply: config => {
        const id = /cropApplication\/(.*)/.exec(config.url)[1];
        const data = cropApplication.find(crop => crop.id===id);
        return [200, data];
    }
}];

export default cropApplicationService;